import React from "react";
import { Wrapper } from "./SocialNavigation.styles"

import linkedinIcon from "../../images/social-icons/linkedin.svg"
import instagramIcon from "../../images/social-icons/instagram.png"
import youtubeIcon from "../../images/social-icons/youtube.png"
import twitterIcon from "../../images/social-icons/twitter.svg"


const SocialNavigation = ({ menu }) => {

    const getIcon = (name) => {
        let icon;
        switch(name){
            case 'LinkedIn': 
                icon = linkedinIcon;
            break;
            case 'Youtube': 
                icon = youtubeIcon;
            break;
            case 'Instagram': 
                icon = instagramIcon;
            break;
            case 'Twitter': 
                icon = twitterIcon;
            break;
            default:
                icon = null;
        }
        return icon;
    }

    menu.forEach(element => {
        //console.log('--> '+element.label)
    });

    return(
        <Wrapper>
            <ul>
                {menu.map(mainItem => (
                    <li key={mainItem.id}>
                        <a href={mainItem.url} target={mainItem.target} className={mainItem.cssClasses.join(' ')}>
                            <img src={ getIcon(mainItem.cssClasses.join(''))} alt={mainItem.cssClasses.join('')}/>
                        </a>
                    </li>
                ))}
            </ul>
        </Wrapper>
    )
}

export default SocialNavigation;